import React from "react";
import Basic from "../containers/SubmittedCaseDetails/CardTabs/Basic"
import Dispatch from "../containers/SubmittedCaseDetails/CardTabs/Dispatch"
import Risk from "../containers/SubmittedCaseDetails/CardTabs/Risk"
import Proposal from "../containers/SubmittedCaseDetails/CardTabs/Proposal";
import Policy from "../containers/SubmittedCaseDetails/CardTabs/Policy";
import Claim from "../containers/SubmittedCaseDetails/CardTabs/Claim";
import Endorsement from "../containers/SubmittedCaseDetails/CardTabs/Endrosement";
// import InvestigatorInvestigation from "../containers/SubmittedCaseDetails/CardTabs/Investigation/InvestigatorInvestigation";
import Investigation from "../containers/SubmittedCaseDetails/CardTabs/Investigation/Investigation";
import External from "../containers/SubmittedCaseDetails/CardTabs/External";
const vendorCardData = [
    {
      tabId: '1',
      tabTitle: 'Investigator',
      tabContent:<Investigation />
    },
    {
      tabId: '2',
      tabTitle: 'Basic',
      tabContent: <Basic />
    },
    {
      tabId: '3',
      tabTitle: 'Policy',
      tabContent: <Policy />
    },
    {
      tabId: '4',
      tabTitle: 'Claim',
      tabContent:<Claim />
    },
    {
      tabId: '5',
      tabTitle: 'Proposal',
      tabContent: <Proposal />
    },
    {
      tabId: '6',
      tabTitle: 'Dispatch',
      tabContent: <Dispatch />
    }, 
    {
      tabId: '7',
      tabTitle: 'Risk',
      tabContent: <Risk />
    },
    {
      tabId: '8',
      tabTitle: 'Endorsement',
      tabContent: <Endorsement />
    },
    {
      tabId: '9',
      tabTitle: 'External',
      tabContent: <External />
    }
  ]

//   const investigatorCardData = [
//     {
//       tabId: '1',
//       tabTitle: 'Investigation',
//       tabContent: <InvestigatorInvestigation />
//     },
//     {
//       tabId: '2',
//       tabTitle: 'Basic',
//       tabContent: <Basic />
//     },
//     {
//       tabId: '3',
//       tabTitle: 'Policy',
//       tabContent: <Policy />
//     },
//     {
//       tabId: '4',
//       tabTitle: 'Claim',
//       tabContent: <Claim />
//     },
//     {
//       tabId: '5',
//       tabTitle: 'Proposal',
//       tabContent: <Proposal />
//     },
//     {
//       tabId: '6',
//       tabTitle: 'Dispatch',
//       tabContent: <Dispatch />
//     },
//     {
//       tabId: '7',
//       tabTitle: 'Risk',
//       tabContent: <Risk />
//     },
//     {
//       tabId: '8',
//       tabTitle: 'Endorsement',
//       tabContent: <Endorsement />
//     },
//     {
//       tabId: '9',
//       tabTitle: 'External',
//       tabContent: <External />
//     }
//   ]

  export {vendorCardData}